import React from 'react';
import { Search, ShoppingCart, Menu } from 'lucide-react';
export function Header() {
  return <header className="pt-4 md:pt-6 pb-2 border-b-2 border-black" data-id="element-56">
      {/* Mobile Layout */}
      <div className="md:hidden" data-id="element-57">
        {/* Top Row: Hamburger + Search | Logo */}
        <div className="flex items-center justify-between mb-4" data-id="element-58">
          <div className="flex items-center gap-4" data-id="element-59">
            <button className="text-black" data-id="element-60">
              <Menu className="w-7 h-7" strokeWidth={2.5} data-id="element-61" />
            </button>
            <button className="text-black" data-id="element-62">
              <Search className="w-6 h-6" strokeWidth={2.5} data-id="element-63" />
            </button>
          </div>
          <a href="/" className="inline-block" data-id="element-64">
            <h1 className="font-oswald text-3xl font-bold tracking-tighter text-black leading-none" data-id="element-65">
              MEAT+POULTRY
            </h1>
          </a>
        </div>
        {/* Subscribe Button */}
        <div className="flex justify-center pb-2" data-id="element-66">
          <button className="bg-[#38bdf8] text-white px-8 py-2.5 rounded font-semibold text-base" data-id="element-67">
            Subscribe for Free
          </button>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col md:flex-row justify-between items-end gap-4" data-id="element-68">
        {/* Logo */}
        <a href="/" className="inline-block" data-id="element-69">
          <h1 className="font-oswald text-5xl md:text-6xl font-bold tracking-tighter text-black leading-none" data-id="element-70">
            MEAT+POULTRY
          </h1>
        </a>

        {/* Right Actions */}
        <div className="flex items-center gap-5 text-sm font-medium" data-id="element-71">
          <a href="#" className="hover:underline text-gray-800" data-id="element-72">
            SIGN IN
          </a>
          <a href="#" className="hover:underline text-gray-800" data-id="element-73">
            CREATE ACCOUNT
          </a>

          <div className="flex items-center border-b-2 border-black pb-1 ml-2" data-id="element-74">
            <input type="text" placeholder="Search" className="outline-none w-32 md:w-48 text-sm placeholder-gray-500" data-id="element-75" />
            <button className="text-black hover:text-gray-600" data-id="element-76">
              <Search className="w-4 h-4 font-bold" strokeWidth={3} data-id="element-77" />
            </button>
          </div>

          <button className="text-black hover:text-gray-600" data-id="element-78">
            <ShoppingCart className="w-5 h-5" data-id="element-79" />
          </button>

          <button className="bg-[#38bdf8] text-white px-5 py-2 rounded font-semibold hover:bg-sky-500 transition-colors" data-id="element-80">
            Subscribe for Free
          </button>
        </div>
      </div>
    </header>;
}